var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map_Marker_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haldus",
    transform: "translate(-988.000000, -326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3",
    transform: "translate(208.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(564.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map_Marker",
    transform: "translate(216.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9290711,22.6061558 L14.0045715,32 L4.08007203,22.6061558 C-1.36002401,17.4569375 -1.36002401,9.10685377 4.08007203,3.95763616 L4.15358684,3.88805213 C9.59368287,-1.26116687 18.3419454,-1.3307509 23.8555563,3.88805143 C29.3691671,9.10685377 29.3691671,17.4569375 23.9290711,22.6061558 Z",
    id: "Stroke-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14 C18,16.209136 16.209136,18 14,18 C11.790864,18 10,16.209136 10,14 C10,11.790864 11.790864,10 14,10 C16.209136,10 18,11.790864 18,14 Z",
    id: "Stroke-3",
    fill: "#FFCD00"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/Map_Marker.10424e0d2c9cd9d822e41fe6efb1b7a9.svg";
export { ForwardRef as ReactComponent };